import * as yup from "yup";

export const customerDocumentSchema = yup.object().shape({
  name: yup
    .string()
    .required()
    .label("Name")
    .default("")
    .transform((value) => value ?? ""),
  note: yup
    .string()
    .label("Note")
    .default("")
    .transform((value) => value ?? ""),
  file: yup.mixed().label("File"),
  customerId: yup.string().required().default("").label("Customer"),
});
